import { ref } from 'vue';

// Estado reactivo para almacenar el número de proveedores
const supplierCount = ref<number>(0);

// Umbral a partir del cual se aplica caché
const CACHE_THRESHOLD = 10;

/**
 * Actualiza el contador de proveedores
 * @param count Nuevo número de proveedores
 */
function setSupplierCount(count: number): void {
  supplierCount.value = count;
}

/**
 * Verifica si se debe aplicar caché basado en el número de proveedores
 * @returns true si se debe aplicar caché, false en caso contrario
 */
function shouldApplyCache(): boolean {
  return supplierCount.value >= CACHE_THRESHOLD;
}

/**
 * Obtiene el número actual de proveedores
 * @returns El número de proveedores
 */
function getSupplierCount(): number {
  return supplierCount.value;
}

/**
 * Limpia el contador de proveedores
 */
function clearSupplierData(): void {
  supplierCount.value = 0;
}

export default {
  setSupplierCount,
  shouldApplyCache,
  getSupplierCount,
  clearSupplierData,
  CACHE_THRESHOLD
};
